export default {
    text: {
        facebook: `Add your Facebook fanpage to access your stats`,
        twitter: `Add your Twitter account to access your stats`,
        instagram: `Register your Instagram account`,
        tiktok: `Add your Tiktok account to access your stats`,
        youtube: `Add your Youtube channel to access your stats`,
    },
};
